import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import CustomLink from '../components/CustomLink'
import FancyInput from '../elements/FancyInput'
import InputRow from '../elements/InputRow'
import {BRAND_EXETEL} from "../constants";

const Success = (
    <div className='text-center'>
        <p>Thanks. We've just sent you an email letting you know how to reset your password. You should receive it in the next few minutes.</p>
        <p>If you don't receive an email, please double check your junk folder or contact Exetel support on 13 39 38.</p>
    </div>
)

const options = {
    postUrl: '/api/auth/postForgotPasswordForm',
    success: Success
}

const state = {
    brand: BRAND_EXETEL
}

const ForgotPasswordForm = (props) => {
    return (
        <form onSubmit={props.handleSubmit} onKeyDown={props.handleKeyDown}>
            <InputRow
                label='Username'
                name='username'
                value={props.values.username}
                errors={props.errors}
                handleChange={props.handleInputChange}
                autoComplete='username'
                placeholder='Username'
            />
            <InputRow
                label='Contact Email'
                name='contact'
                value={props.values.contact}
                errors={props.errors}
                handleChange={props.handleInputChange}
                placeholder='The contact email you provided to Exetel'
            />

            {props.children}

            <div className='mt-4'>
                <Button title='Reset Password' action={props.handleSubmit} />
            </div>
        </form>
    )
}

export default FormHOC(ForgotPasswordForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/ForgotPasswordForm.js